import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {UserService} from '../user/user.service';
import {Roles} from "@app/shared";

@Injectable()


export class KeycloakGuardService implements CanActivate {

  constructor (private user: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const fromUrl = route.parent.url;
    const toUrl = route.url;
    const roles = route.data["roles"] as Array<Roles>;

    // debugging
    console.debug(`Angular: Routing request from [${fromUrl}] to [${state.url}]=`);

    if (!this.user.authenticated) {
      console.debug(`Angular: Saving user.routeToAfterAuthenticated = [${state.url}]`);
      this.user.routeToAfterAuthenticated = state.url;
      return false;
    }

    return this.user.isAuthorized(roles);
  }

}
